import { makeStyles } from '@material-ui/core';
import CategoryIcon from '@material-ui/icons/List';
import React from 'react';
import {
  Datagrid,
  List,
  Responsive,
  TextInput,
  SelectInput,
  SimpleList,
  TextField,
  TopToolbar,
  Pagination
} from 'react-admin';

import LinkField from '../../core/components/LinkField';
import Empty from '../../core/components/list/Empty';
import Filter from '../../core/components/list/StyledFilter';
import ListTitleBar from '../../core/components/ListTitleBar';
import StatusSelectField from '../../core/components/StatusSelectField';
import {
  predictiveSearchFormatter,
  predictiveSearchParser
} from '../../core/utils';
import { categoryStatus } from './CategoryLookups';

const useStyles = makeStyles({
  filters: {
    minWidth: '225px'
  },
  statusColumnStyle: {
    width: '74px'
  },
  root: {
    marginRight: 'auto'
  }
});

const Actions = ({
  displayedFilters,
  filters,
  filterValues,
  resource,
  showFilter
}) => {
  const classes = useStyles();

  return (
    <TopToolbar classes={{ root: classes.root }}>
      {filters &&
        React.cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button'
        })}
    </TopToolbar>
  );
};

const CategoryFilters = props => {
  const classes = useStyles();

  return (
    <Filter variant="standard" {...props}>
      <TextInput
        label="Search by Category Name"
        source="name"
        alwaysOn
        className={classes.filters}
        parse={predictiveSearchParser}
        format={predictiveSearchFormatter}
        options={{ autoComplete: 'off' }}
      />
      <SelectInput
        label="Status"
        source="status"
        choices={categoryStatus}
        allowEmpty
      />
    </Filter>
  );
};
const CategoryTitle = props => {
  return (
    <ListTitleBar
      type="Document Categories"
      title="Create New Category"
      id="Create New Category"
      createUrl="#/categories/create"
      icon={<CategoryIcon />}
      hasCreatePermission={props.hasCreatePermission}
    />
  );
};

const CategoryList = props => {
  const classes = useStyles();
  const {
    hasCreatePermission,
    hasEditPermission,
    hasDeletePermission,
    userProfile,
    ...rest
  } = props;

  return (
    <List
      {...rest}
      sort={{ field: 'status', order: 'ASC' }}
      exporter={false}
      title={<CategoryTitle hasCreatePermission={hasCreatePermission} />}
      filters={<CategoryFilters />}
      perPage={20}
      pagination={<Pagination rowsPerPageOptions={[20, 25, 30]} />}
      filter={{ subType: 'REPORTING', orphanVisibility: 'ALL_VISIBLE' }}
      bulkActionButtons={false}
      actions={<Actions />}
      empty={<Empty />}
      syncWithLocation
    >
      <Responsive
        small={
          <SimpleList
            primaryText={record => record.name}
            secondaryText={record => record.id}
            tertiaryText={() => ''}
          />
        }
        medium={
          <Datagrid>
            <LinkField label="Category Name" source="name" />
            <TextField label="Description" source="description" />
            <StatusSelectField
              label="Status"
              source="status"
              choices={categoryStatus}
              headerClassName={classes.statusColumnStyle}
            />
          </Datagrid>
        }
      />
    </List>
  );
};

export default CategoryList;
